import type {
  NotificationService,
  NotificationSubscriber,
  NotificationType,
} from '../application/NotificationService';
import { v4 as uuid } from 'uuid';
import { NotificationSubscriberId } from '../application/NotificationService';

export class SimpleNotificationService implements NotificationService {
  subscribers: Map<NotificationSubscriberId, NotificationSubscriber>;

  constructor() {
    this.subscribers = new Map();
  }

  subscribe(subscriber: NotificationSubscriber) {
    const id = NotificationSubscriberId(uuid());
    this.subscribers.set(id, subscriber);
    return id;
  }

  unsubscribe(id: NotificationSubscriberId) {
    this.subscribers.delete(id);
  }

  notify(notification: NotificationType) {
    this.subscribers.forEach(subscriber => {
      return subscriber.handleNewNotification({
        ...notification,
        id: uuid(),
      });
    });
  }
}
